import { render } from "./StepThree.vue?vue&type=template&id=54f5d5bd&scoped=true"
import script from "./StepThree.vue?vue&type=script&lang=js"
export * from "./StepThree.vue?vue&type=script&lang=js"

import "./StepThree.vue?vue&type=style&index=0&id=54f5d5bd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f5d5bd"]])

export default __exports__